<div class="documents-page">

  <!-- =====================================================
       PAGE HEADER
  ====================================================== -->
  <div class="documents-page__header">

    <div class="documents-page__title-area">
      <!-- <div class="documents-page__icon">
        <i class="pi pi-folder-open"></i>
      </div> -->

      <div>
        <h1>
          {{ isAdminRole ? 'All Documents' : 'My Documents' }}
        </h1>

        <p>
          {{ isAdminRole
          ? 'Manage and organize documents available to your employees.'
          : 'View and explore the documents available to you.'
          }}
        </p>
      </div>
    </div>

    <div class="documents-page__actions">

      <button type="button" class="btn btn-light" (click)="openCreateFolder()">

        <i class="pi pi-folder-plus"></i>
        <span>New Folder</span>
      </button>

      <!-- <button type="button" class="btn btn-primary" (click)="openUploadDocument()">

        <i class="pi pi-upload"></i>
        <span>Upload Document</span>
      </button> -->

    </div>

  </div>


  <!-- =====================================================
       DOCUMENT WORKSPACE
  ====================================================== -->
  <div class="documents-workspace" [class.sidebar-collapsed]="isFolderSidebarCollapsed">

    <!-- =====================================================
       LEFT FOLDER SIDEBAR
  ====================================================== -->
    <aside class="folder-sidebar">

      <!-- Sidebar Header -->
      <div class="folder-sidebar__header">

        <div class="folder-sidebar__heading" *ngIf="!isFolderSidebarCollapsed">
        </div>

        <button type="button" class="sidebar-toggle" pTooltip [tooltipPosition]="'right'"
          [tooltipDisabled]="!isFolderSidebarCollapsed" [tooltipOptions]="{
    showDelay: 300
  }" [ngStyle]="{}" [attr.aria-label]="
    isFolderSidebarCollapsed
      ? 'Expand folders'
      : 'Collapse folders'
  " [pTooltip]="
    isFolderSidebarCollapsed
      ? 'Expand folders'
      : 'Collapse folders'
  " (click)="toggleFolderSidebar()">

          <i class="pi" [ngClass]="
      isFolderSidebarCollapsed
        ? 'pi-angle-right'
        : 'pi-angle-left'
    ">
          </i>

        </button>

      </div>


      <!-- Folder Search -->
      <div class="folder-search" *ngIf="!isFolderSidebarCollapsed">

        <i class="pi pi-search"></i>

        <input type="text" placeholder="Search folders..." [(ngModel)]="folderSearch" />

      </div>


      <!-- Folder List -->
      <div class="folder-list">

        <button type="button" class="folder-item" *ngFor="let folder of folders"
          [class.active]="selectedFolderId === folder.group_id" [title]="
        isFolderSidebarCollapsed
          ? folder.full_name
          : ''
      " (click)="selectFolder(folder.group_id)">

          <!-- Folder Icon -->
          <div class="folder-item__icon" [class.private]="folder.isPrivate" [class.active-icon]="
          selectedFolderId === folder.group_id
        ">

            <i [ngClass]="
            folder.groupIcon || 'pi pi-folder'
          ">
            </i>

          </div>


          <!-- Folder Information -->
          <div class="folder-item__content" *ngIf="!isFolderSidebarCollapsed">

            <span class="folder-item__name" [pTooltip]="folder.full_name" tooltipPosition="right"
              [tooltipDisabled]="!isFolderSidebarCollapsed">

              {{ folder.full_name }}

              <i *ngIf="folder.isPrivate" class="pi pi-lock folder-private-icon" pTooltip="Private folder"
                tooltipPosition="top">
              </i>

            </span>

          </div>


          <!-- Folder Actions -->
          <div class="folder-item__actions" *ngIf="!isFolderSidebarCollapsed">

            <!-- Open Folder -->
            <!-- <i class="pi pi-angle-right folder-item__arrow">
            </i> -->

            <!-- Delete Folder -->
            @if(isAdminRole){

            <button type="button" class="folder-edit-btn" title="Edit folder" aria-label="Edit folder"
              (click)="openEditFolderModal(folder); $event.stopPropagation()">

              <i class="pi pi-pencil"></i>

            </button>

            <button type="button" class="folder-delete-btn" title="Delete folder" aria-label="Delete folder"
              (click)="deleteFolder(folder); $event.stopPropagation()">

              <i class="pi pi-trash"></i>

            </button>
            }

          </div>

        </button>

      </div>

    </aside>


    <!-- =====================================================
       RIGHT DOCUMENT CONTENT
  ====================================================== -->

    <main class="documents-content">


      <!-- =================================================
           CONTENT HEADER
      ================================================== -->
      <div class="documents-content__header">

        <div class="documents-content__heading">

          <div class="breadcrumb">

            <span>Documents</span>

            <i class="pi pi-angle-right"></i>

            <strong>
              {{ selectedFolderName }}
            </strong>

          </div>

          <div class="document-count">
            {{ filteredDocuments.length }} documents
          </div>

        </div>


        <div class="documents-content__actions">

          <!--AI Search-->
          @if(SelectFolderModelType === 1 || SelectFolderModelType === 3){
          <button type="button" class="btn btn-ai" (click)="navigate('search')">

            <i class="pi pi-sparkles"></i>

            <span>AI Search</span>

          </button>
          }

          <!-- Ask Question -->

          @if(SelectFolderModelType === 1 || SelectFolderModelType === 2 || SelectFolderModelType === 3 ||
          SelectFolderModelType === 4){
          <button type="button" class="btn btn-ai" (click)="navigate('answer')">

            <i class="pi pi-sparkles"></i>

            <span>AI Question Answers</span>

          </button>
          }


          <!-- Upload -->
          <button type="button" class="btn btn-primary" (click)="openUploadDocument()">

            <i class="pi pi-upload"></i>

            <span>Upload</span>

          </button>


          <!-- View Switch -->
          <div class="view-switch">

            <button type="button" [class.active]="viewMode === 'grid'" (click)="viewMode = 'grid'" title="Grid view">

              <i class="pi pi-th-large"></i>

            </button>

            <!-- <button type="button" [class.active]="viewMode === 'list'" (click)="viewMode = 'list'" title="List view">

              <i class="pi pi-list"></i>

            </button> -->

          </div>

        </div>

      </div>



      <!-- =================================================
           TOOLBAR
      ================================================== -->
      <div class="documents-toolbar">

        <div class="documents-search">

          <i class="pi pi-search"></i>

          <input type="text" placeholder="Search documents..." [(ngModel)]="documentSearch" />

        </div>


        <!-- <div class="documents-toolbar__right">

          <button type="button" class="filter-button">

            <i class="pi pi-filter"></i>
            Filter

          </button>

          <button type="button" class="sort-button">

            <i class="pi pi-sort-alt"></i>
            Recently Added
            <i class="pi pi-chevron-down"></i>

          </button>

        </div> -->

      </div>



      <!-- =================================================
           EMPTY STATE
      ================================================== -->
      <div class="documents-empty" *ngIf="filteredDocuments.length === 0">

        <div class="documents-empty__illustration">
          <i class="pi pi-file"></i>
        </div>

        <h3>No documents found</h3>

        <p>
          Upload documents to this folder to start building
          your knowledge library.
        </p>

        <button type="button" class="btn btn-primary" (click)="openUploadDocument()">

          <i class="pi pi-upload"></i>
          Upload Document

        </button>

      </div>



      <!-- =================================================
           GRID VIEW
      ================================================== -->
      <div class="document-selection-bar" *ngIf="filteredDocuments.length > 0">

        <label class="document-select-all">
          <input type="checkbox" [checked]="isAllDocumentsSelected()" [indeterminate]="isSomeDocumentsSelected()"
            (change)="toggleSelectAll($event)" />

          <span class="document-select-all__box"></span>

          <span>
            Select All
          </span>
        </label>

        <span class="document-selection-count" *ngIf="selectedDocuments.length > 0">
          {{ selectedDocuments.length }} document{{ selectedDocuments.length > 1 ? 's' : '' }} selected
        </span>

        <button type="button" class="bulk-action-btn" *ngIf="selectedDocuments.length > 0"
          (click)="deleteSelectedDocuments()">
          <i class="pi pi-trash"></i>
          Delete Selected
        </button>

      </div>


      <!-- ================================
     DOCUMENT GRID
================================ -->
      <div class="document-grid" *ngIf="viewMode === 'grid' && filteredDocuments.length > 0">

        <article class="document-card" *ngFor="let document of filteredDocuments; let i=index;"
          [class.document-card--selected]="isDocumentSelected(document)">

          <!-- =========================================
         PREVIEW
    ========================================== -->
          <div class="document-card__preview" [ngClass]="getFileClass(document.file_ext)">

            <!-- Document Checkbox -->
            <label class="document-card__checkbox" (click)="$event.stopPropagation()" title="Select document"
              *ngIf="document.file_type === 'application'">

              <input type="checkbox" [checked]="isDocumentSelected(document)"
                (change)="toggleDocumentSelection(document, $event)" />

              <span class="document-card__checkbox-box">
                <i class="pi pi-check"></i>
              </span>

            </label>


            <div class="document-card__file-icon">
              <i class="pi" [ngClass]="getFileIcon(document.file_ext)"></i>
            </div>

            <span class="document-card__file-type">
              {{ document.file_ext | uppercase }}
            </span>


            <!-- More -->
            <div class="document-card__menu-wrapper">

              <button type="button" class="document-card__menu" title="More options"
                (click)="toggleDocumentMenu($event, document)">
                <i class="pi pi-ellipsis-v"></i>
              </button>

              <div class="document-card__dropdown" *ngIf="activeDocumentMenu === document.message_id"
                (click)="$event.stopPropagation()">

                <button type="button" class="document-card__dropdown-item" (click)="editDocument(document, index)">
                  <span class="dropdown-icon dropdown-icon--edit">
                    <i class="pi pi-pencil"></i>
                  </span>
                  <span>Edit Content</span>
                </button>

                <button type="button" class="document-card__dropdown-item" *ngIf="is_download === true"
                  (click)="downloadDocument(document)">
                  <span class="dropdown-icon dropdown-icon--download">
                    <i class="pi pi-download"></i>
                  </span>
                  <span>Download</span>
                </button>

                <div class="document-card__dropdown-divider"></div>

                <button type="button" class="document-card__dropdown-item document-card__dropdown-item--danger"
                  (click)="deleteDocument(document)">
                  <span class="dropdown-icon dropdown-icon--delete">
                    <i class="pi pi-trash"></i>
                  </span>
                  <span>Delete</span>
                </button>

                <ng-container *ngIf="document.is_question_found === true">

                  <div class="document-card__dropdown-divider"></div>

                  <button type="button" class="document-card__dropdown-item" (click)="openAssessment(document, index)">
                    <span class="dropdown-icon dropdown-icon--assessment">
                      <i class="pi pi-check-square"></i>
                    </span>
                    <span>Assessment</span>
                  </button>

                </ng-container>

                <button type="button" class="document-card__dropdown-item" *ngIf="document.is_survey_found === true"
                  (click)="openSurvey(document, index)">
                  <span class="dropdown-icon dropdown-icon--survey">
                    <i class="pi pi-file-edit"></i>
                  </span>
                  <span>Survey</span>
                </button>

                <button type="button" class="document-card__dropdown-item" *ngIf="document.is_polls_found === true"
                  (click)="openPoll(document, index)">
                  <span class="dropdown-icon dropdown-icon--poll">
                    <i class="pi pi-chart-bar"></i>
                  </span>
                  <span>Poll</span>
                </button>

                <button type="button" class="document-card__dropdown-item" *ngIf="document.is_notes_found"
                  (click)="openNotes(document, index)">
                  <span class="dropdown-icon dropdown-icon--notes">
                    <i class="pi pi-book"></i>
                  </span>
                  <span>Notes</span>
                </button>

              </div>
            </div>

          </div>


          <!-- =========================================
         BODY
    ========================================== -->
          <div class="document-card__body">

            <div class="document-card__title-row">

              <h3 class="document-card__title" [title]="document.message">
                {{ document.message }}
              </h3>

            </div>

            <div class="document-card__meta">

              <span class="document-card__meta-item">
                <i class="pi pi-file"></i>
                {{ document.file_size }}
              </span>

              <span class="document-card__meta-dot"></span>

              <span class="document-card__meta-item">
                <i class="pi pi-calendar"></i>
                {{ document.createdAt }}
              </span>

            </div>

            <div class="document-card__folder">

              <span class="document-card__folder-icon">
                <i class="pi pi-folder"></i>
              </span>

              <span class="document-card__folder-name" [title]="selectedFolderName">
                {{ selectedFolderName }}
              </span>

            </div>

          </div>


          <!-- =========================================
         FOOTER ACTIONS
    ========================================== -->
          <div class="document-card__footer">

            <button type="button" class="document-action document-action--preview" (click)="previewDocument(document)"
              title="Preview document">
              <span class="document-action__icon">
                <i class="pi pi-eye"></i>
              </span>

              <span class="document-action__label">
                Preview
              </span>
            </button>


            <button type="button" class="document-action document-action--publish"
              [class.document-action--published]="document.is_publish === true"
              [disabled]="document.is_publish === true" (click)="documentPublish(document, index)"
              [title]="document.is_publish ? 'Document published' : 'Publish document'">
              <span class="document-action__icon">
                <i class="bi" [ngClass]="document.is_publish ? 'bi-check-circle-fill' : 'bi-send'"></i>
              </span>

              <span class="document-action__label">
                {{ document.is_publish ? 'Published' : 'Publish' }}
              </span>
            </button>


            <button type="button" class="document-action document-action--summary" *ngIf="document.summary"
              (click)="openSummary(document)" title="View summary">
              <span class="document-action__icon">
                <i class="pi pi-align-left"></i>
              </span>

              <span class="document-action__label">
                Summary
              </span>
            </button>

          </div>

        </article>

      </div>



      <!-- =====================================================
     DOCUMENT LIST
====================================================== -->
      <div class="document-list" *ngIf="viewMode === 'list' && filteredDocuments.length > 0">
        <!-- ===============================
       LIST HEADER
  ================================ -->
        <div class="document-list__header">

          <!-- Select All -->
          <div class="col-select">
            <label class="list-checkbox" title="Select all documents">
              <input type="checkbox" [checked]="isAllDocumentsSelected()" [indeterminate]="isSomeDocumentsSelected()"
                (change)="toggleSelectAll($event)" />

              <span class="list-checkbox__box">
                <i class="pi pi-check"></i>
              </span>
            </label>
          </div>

          <span class="col-name">Document</span>
          <span class="col-folder">Folder</span>
          <span class="col-size">Size</span>
          <span class="col-date">Created At</span>
          <span class="col-action">Action</span>
        </div>


        <!-- ===============================
       DOCUMENT ROW
  ================================ -->
        <div class="document-row" *ngFor="let document of filteredDocuments; let i=index"
          [class.document-row--selected]="isDocumentSelected(document)">

          <!-- Checkbox -->
          <div class="document-row__select">
            <label class="list-checkbox" title="Select document" (click)="$event.stopPropagation()"
              *ngIf="document.file_type === 'application'">
              <input type="checkbox" [checked]="isDocumentSelected(document)"
                (change)="toggleDocumentSelection(document, $event)" />

              <span class="list-checkbox__box">
                <i class="pi pi-check"></i>
              </span>
            </label>
          </div>

          <!-- ===============================
         DOCUMENT
    ================================ -->
          <div class="document-row__name">

            <div class="document-row__icon" [ngClass]="getFileClass(document.file_ext)">
              <i class="pi" [ngClass]="getFileIcon(document.file_ext)"></i>
            </div>

            <div class="document-row__details">

              <strong [title]="document.message">
                {{ document.message }}
              </strong>

              <div class="document-row__meta">
                <!-- <span>
                  {{ document.file_type | uppercase }}
                </span>

                <span class="meta-dot">•</span>

                <span>
                  {{ document.file_size }}
                </span> -->
              </div>

            </div>

          </div>


          <!-- ===============================
         FOLDER
    ================================ -->
          <div class="document-row__folder">

            <div class="folder-icon">
              <i class="pi pi-folder"></i>
            </div>

            <span [title]="selectedFolderName">
              {{ selectedFolderName }}
            </span>

          </div>


          <!-- ===============================
         SIZE
    ================================ -->
          <div class="document-row__size">
            {{ document.file_size }}
          </div>


          <!-- ===============================
         DATE
    ================================ -->
          <div class="document-row__date">
            <span>{{ document.created_at }}</span>
          </div>


          <!-- ===============================
         ACTIONS
    ================================ -->
          <div class="document-row__actions">

            <!-- Preview -->
            <button type="button" class="action-btn" title="Preview" (click)="previewDocument(document)">
              <i class="pi pi-eye"></i>
            </button>


            <!-- Summary -->
            <button type="button" class="action-btn" title="View Summary" *ngIf="document.summary"
              (click)="openSummary(document)">
              <i class="pi pi-align-left"></i>
            </button>


            <!-- More -->
            <div class="document-menu-wrapper">

              <button type="button" class="action-btn action-btn--more" title="More actions"
                [class.is-active]="activeDocumentMenu === document" (click)="toggleDocumentMenu($event, document)">
                <i class="pi pi-ellipsis-v"></i>
              </button>


              <!-- ===============================
             DROPDOWN MENU
        ================================ -->
              <div class="document-action-menu" *ngIf="activeDocumentMenu === document"
                (click)="$event.stopPropagation()">

                <button type="button" class="document-action-menu__item"
                  (click)="previewDocument(document); closeDocumentMenu()">
                  <span class="menu-icon menu-icon--blue">
                    <i class="pi pi-eye"></i>
                  </span>

                  <span class="menu-content">
                    <strong>Preview</strong>
                    <small>View document</small>
                  </span>
                </button>


                <button type="button" class="document-action-menu__item" *ngIf="document.summary"
                  (click)="openSummary(document); closeDocumentMenu()">
                  <span class="menu-icon menu-icon--purple">
                    <i class="pi pi-align-left"></i>
                  </span>

                  <span class="menu-content">
                    <strong>Summary</strong>
                    <small>Read AI summary</small>
                  </span>
                </button>


                <div class="menu-divider"></div>


                <button type="button" class="document-action-menu__item"
                  (click)="downloadDocument(document); closeDocumentMenu()">
                  <span class="menu-icon menu-icon--green">
                    <i class="pi pi-download"></i>
                  </span>

                  <span class="menu-content">
                    <strong>Download</strong>
                    <small>Save a copy</small>
                  </span>
                </button>


                <button type="button" class="document-action-menu__item"
                  (click)="renameDocument(document); closeDocumentMenu()">
                  <span class="menu-icon menu-icon--orange">
                    <i class="pi pi-pencil"></i>
                  </span>

                  <span class="menu-content">
                    <strong>Rename</strong>
                    <small>Change file name</small>
                  </span>
                </button>


                <div class="menu-divider"></div>


                <button type="button" class="document-action-menu__item document-action-menu__item--danger"
                  (click)="deleteDocument(document); closeDocumentMenu()">
                  <span class="menu-icon menu-icon--red">
                    <i class="pi pi-trash"></i>
                  </span>

                  <span class="menu-content">
                    <strong>Delete</strong>
                    <small>Remove document</small>
                  </span>
                </button>

              </div>

            </div>

          </div>

        </div>
      </div>

    </main>

  </div>

</div>


<!-- =========================================================
     CREATE / EDIT FOLDER MODAL
========================================================== -->
<div class="folder-modal-backdrop" *ngIf="showFolderModal" (click)="closeFolderModal()">
  <div class="folder-modal-card" (click)="$event.stopPropagation()">

    <!-- =====================================================
         HEADER
    ====================================================== -->
    <div class="folder-modal-header">

      <div class="folder-modal-title">

        <div class="folder-modal-title__icon" [class.edit]="isEditFolder">
          <i class="pi" [ngClass]="isEditFolder ? 'pi-pencil' : 'pi-folder-plus'"></i>
        </div>

        <div class="folder-modal-title__content">

          <!-- <div class="folder-modal-title__badge">
            <i class="pi pi-folder"></i>
            Document Folder
          </div> -->

          <h3>
            {{ isEditFolder ? 'Edit Folder' : 'Create New Folder' }}
          </h3>

          <p>
            {{
            isEditFolder
            ? 'Update the folder details and access settings.'
            : 'Create a folder to organize and manage your documents.'
            }}
          </p>

        </div>

      </div>

      <button type="button" class="folder-modal-close" aria-label="Close" (click)="closeFolderModal()">
        <i class="pi pi-times"></i>
      </button>

    </div>


    <!-- =====================================================
         BODY
    ====================================================== -->
    <div class="folder-modal-body">

      <!-- ===================================================
           BASIC INFORMATION
      ==================================================== -->
      <div class="form-section">

        <div class="form-section-heading">
          <div class="form-section-heading__icon">
            <i class="pi pi-info-circle"></i>
          </div>

          <div>
            <h4>Basic Information</h4>
            <p>Enter the details for this document folder.</p>
          </div>
        </div>


        <!-- Folder Name -->
        <div class="form-group">

          <label for="folderName">
            Folder Name
            <span class="required">*</span>
          </label>

          <div class="input-wrapper">

            <i class="pi pi-folder input-icon"></i>

            <input id="folderName" type="text" class="form-control" placeholder="e.g. Training Materials"
              [(ngModel)]="newFolderName" maxlength="100" />

            <span class="input-counter">
              {{ newFolderName?.length || 0 }}/100
            </span>

          </div>

          <small class="form-hint">
            Use a clear and recognizable name for this folder.
          </small>

        </div>


        <!-- Description -->
        <div class="form-group">

          <div class="label-row">

            <label for="folderDescription">
              Description
            </label>

            <span class="optional-label">
              Optional
            </span>

          </div>

          <textarea id="folderDescription" class="form-control textarea-control" rows="3"
            placeholder="Add a short description about this folder..." [(ngModel)]="newFolderDescription"
            maxlength="500"></textarea>

          <div class="field-footer">

            <small class="form-hint">
              Briefly describe what documents this folder contains.
            </small>

            <small class="character-count">
              {{ newFolderDescription?.length || 0 }}/500
            </small>

          </div>

        </div>

      </div>


      <!-- ===================================================
           AI CONFIGURATION
      ==================================================== -->
      <div class="form-section">

        <div class="form-section-heading">

          <div class="form-section-heading__icon ai">
            <i class="pi pi-sparkles"></i>
          </div>

          <div>
            <h4>AI Configuration</h4>
            <p>Select the AI model used for this folder.</p>
          </div>

        </div>


        <!-- Model Type -->
        <div class="form-group">

          <label for="modelType">
            Model Type
            <span class="required">*</span>
          </label>

          <div class="model-options">

            <label class="model-option" *ngFor="let model of [
                { value: '1', title: 'Model 1', description: 'Legal Document Trained AI Response 1' },
                { value: '2', title: 'Model 2', description: 'Statuatory Document Trained AI Response' },
                { value: '3', title: 'Model 3', description: 'Legal Document Trained AI Response 2' },
                { value: '4', title: 'Model 4', description: 'Benefit Assist Trained AI Response' }
              ]" [class.active]="newFolderModelType === model.value">

              <input type="radio" name="folderModelType" [value]="model.value" [(ngModel)]="newFolderModelType" />

              <div class="model-option__radio">
                <span></span>
              </div>

              <div class="model-option__icon">
                <i class="pi pi-sparkles"></i>
              </div>

              <div class="model-option__content">
                <strong>{{ model.title }}</strong>
                <small>{{ model.description }}</small>
              </div>

              <i class="pi pi-check model-option__check" *ngIf="newFolderModelType === model.value"></i>

            </label>

          </div>

        </div>

      </div>


      <!-- ===================================================
           ACCESS
      ==================================================== -->
      <div class="form-section">

        <div class="form-section-heading">

          <div class="form-section-heading__icon access">
            <i class="pi pi-shield"></i>
          </div>

          <div>
            <h4>Folder Access</h4>
            <p>Choose who can access the documents in this folder.</p>
          </div>

        </div>


        <div class="access-options">

          <!-- Selected Users -->
          <label class="access-option" [class.active]="newFolderAccess === 'users'">

            <input type="radio" name="folderAccess" value="users" [(ngModel)]="newFolderAccess" />

            <div class="access-option__icon users">
              <i class="pi pi-users"></i>
            </div>

            <div class="access-option__content">

              <strong>Selected Users</strong>

              <span>
                Give access to specific users.
              </span>

            </div>

            <div class="access-option__radio">
              <i class="pi pi-check" *ngIf="newFolderAccess === 'users'"></i>
            </div>

          </label>


          <!-- All Users -->
          <label class="access-option" [class.active]="newFolderAccess === 'all'">

            <input type="radio" name="folderAccess" value="all" [(ngModel)]="newFolderAccess" />

            <div class="access-option__icon public">
              <i class="pi pi-globe"></i>
            </div>

            <div class="access-option__content">

              <strong>All Users</strong>

              <span>
                Everyone in your organization can access it.
              </span>

            </div>

            <div class="access-option__radio">
              <i class="pi pi-check" *ngIf="newFolderAccess === 'all'"></i>
            </div>

          </label>

        </div>


        <!-- =================================================
             USER SELECTION
        ================================================== -->
        <div class="selected-users-panel" *ngIf="newFolderAccess === 'users'">

          <div class="selected-users-panel__header">

            <div>
              <strong>Select Users</strong>

              <span>
                Choose the users who can access this folder.
              </span>
            </div>

            <div class="selected-count">
              <i class="pi pi-users"></i>
              {{ selectedFolderUsers.length }}
              selected
            </div>

          </div>


          <!-- Search -->
          <div class="user-search">

            <i class="pi pi-search"></i>

            <input type="text" placeholder="Search by name or email..." [(ngModel)]="userSearch" />

            <button type="button" *ngIf="userSearch" (click)="userSearch = ''">
              <i class="pi pi-times"></i>
            </button>

          </div>


          <!-- Selected User List -->
          <div class="user-list">

            <div class="user-selection-item" *ngFor="let user of filteredUsers"
              [class.selected]="isUserSelected(user.user_id)" (click)="toggleUser(user.user_id)">

              <input type="checkbox" [checked]="isUserSelected(user.user_id)" (click)="$event.stopPropagation()"
                (change)="toggleUser(user.user_id)" />

              <div class="user-avatar">

                <ng-container *ngIf="user.profile_image; else userInitials">
                  <img [src]="user.profile_image" [alt]="user.first_name + ' ' + user.last_name" />
                </ng-container>

                <ng-template #userInitials>
                  {{ getUserInitials(user) }}
                </ng-template>

              </div>

              <div class="user-info">
                <strong>
                  {{ user.first_name }} {{ user.last_name }}
                </strong>

                <small>
                  {{ user.email_id }}
                </small>
              </div>

              <div class="user-check">
                <i class="pi pi-check" *ngIf="isUserSelected(user.user_id)"></i>
              </div>

            </div>

            <div class="empty-users" *ngIf="filteredUsers.length === 0">
              <i class="pi pi-users"></i>
              <strong>No users found</strong>
              <span>Try a different search term.</span>
            </div>

          </div>

        </div>

      </div>

    </div>


    <!-- =====================================================
         FOOTER
    ====================================================== -->
    <div class="folder-modal-footer">

      <div class="footer-info">

        <i class="pi pi-info-circle"></i>

        <span>
          {{
          isEditFolder
          ? 'Changes will be applied to this folder.'
          : 'You can manage folder contents after creation.'
          }}
        </span>

      </div>


      <div class="footer-actions">

        <button type="button" class="btn btn-cancel" (click)="closeFolderModal()">
          Cancel
        </button>


        <button type="button" class="btn btn-primary" [disabled]="
            !newFolderName?.trim() ||
            !newFolderModelType ||
            showBtnSpinner
          " (click)="createFolder()" *ngIf="!showBtnSpinner">

          <i class="pi" [ngClass]="isEditFolder ? 'pi-check' : 'pi-folder-plus'"></i>

          {{ isEditFolder ? 'Save Changes' : 'Create Folder' }}

        </button>


        <button type="button" class="btn btn-primary loading" disabled *ngIf="showBtnSpinner">

          <i class="pi pi-spin pi-spinner"></i>

          {{
          isEditFolder
          ? 'Saving Changes...'
          : 'Creating Folder...'
          }}

        </button>

      </div>

    </div>

  </div>
</div>


<!-- =======================================================
     DOCUMENT SUMMARY MODAL
======================================================== -->
<div class="modal-backdrop" *ngIf="showSummaryModal" (click)="closeSummary()">
  <div class="summary-modal" role="dialog" aria-modal="true" aria-labelledby="summary-modal-title"
    (click)="$event.stopPropagation()">

    <!-- =========================
         HEADER
    ========================== -->
    <div class="summary-modal__header">

      <div class="summary-modal__heading">

        <div class="summary-modal__ai-icon">
          <i class="pi pi-sparkles"></i>
        </div>

        <div class="summary-modal__title">
          <div class="summary-modal__title-row">

            <h3 id="summary-modal-title">
              Document Summary
            </h3>

            <span class="ai-badge">
              <i class="pi pi-sparkles"></i>
              AI Generated
            </span>

          </div>

          <p class="summary-modal__document-name" [title]="selectedDocument?.message">
            <i class="pi pi-file"></i>
            {{ selectedDocument?.message }}
          </p>
        </div>

      </div>

      <button type="button" class="summary-modal__close" aria-label="Close summary" (click)="closeSummary()">
        <i class="pi pi-times"></i>
      </button>

    </div>


    <!-- =========================
         BODY
    ========================== -->
    <div class="summary-modal__body">

      <!-- Loading -->
      <div class="summary-loading" *ngIf="summaryLoading">

        <div class="summary-loading__icon">
          <i class="pi pi-sparkles"></i>
        </div>

        <div class="summary-loading__content">

          <h4>Generating your summary</h4>

          <p>
            AI is analyzing the document and preparing the key points.
          </p>

          <div class="summary-loading__bar">
            <span></span>
          </div>

        </div>

      </div>


      <!-- Summary Content -->
      <div class="summary-content" *ngIf="!summaryLoading">

        <div class="summary-content__toolbar">

          <div class="summary-content__label">
            <i class="pi pi-align-left"></i>
            <span>Summary</span>
          </div>

          <span class="summary-content__status">
            <i class="pi pi-check-circle"></i>
            Ready
          </span>

        </div>


        <div class="summary-content__paper">

          <div class="summary-content__accent"></div>

          <div class="summary-content__text">

            <p *ngIf="selectedDocument?.summary">
              {{ selectedDocument?.summary }}
            </p>

            <div class="summary-empty" *ngIf="!selectedDocument?.summary">
              <div class="summary-empty__icon">
                <i class="pi pi-file"></i>
              </div>

              <h4>No summary available</h4>

              <p>
                A summary could not be generated for this document.
              </p>
            </div>

          </div>

        </div>

      </div>

    </div>


    <!-- =========================
         FOOTER
    ========================== -->
    <div class="summary-modal__footer">

      <div class="summary-footer__info">
        <i class="pi pi-info-circle"></i>

        <span>
          Summary generated using AI
        </span>
      </div>

      <button type="button" class="summary-footer__button" (click)="closeSummary()">
        <i class="pi pi-check"></i>
        Done
      </button>

    </div>

  </div>
</div>



<!-- =======================================================
     DOCUMENT PREVIEW MODAL
======================================================== -->
<div class="modal-backdrop document-preview-backdrop" *ngIf="showPreviewModal" (click)="closePreview()">
  <div class="document-preview-modal" (click)="$event.stopPropagation()">

    <!-- =====================================================
         HEADER
    ====================================================== -->
    <header class="document-preview-modal__header">

      <div class="document-preview-modal__brand">

        <div class="document-preview-modal__brand-icon">
          <i class="pi pi-file"></i>
        </div>

        <div class="document-preview-modal__brand-content">
          <h3>Document Preview</h3>

          <p>
            Browse and preview your documents
            <span class="header-dot">•</span>
            {{ filteredDocuments.length }} files
          </p>
        </div>

      </div>

      <button type="button" class="modal-close" title="Close preview" aria-label="Close preview"
        (click)="closePreview()">
        <i class="pi pi-times"></i>
      </button>

    </header>


    <!-- =====================================================
         CONTENT
    ====================================================== -->
    <div class="document-preview-modal__content">


      <!-- =====================================================
           LEFT SIDEBAR
      ====================================================== -->
      <aside class="document-preview-sidebar">

        <div class="document-preview-sidebar__header">

          <div>
            <h4>Documents</h4>

            <span>
              {{ filteredDocuments.length }}
              {{ filteredDocuments.length === 1 ? 'file' : 'files' }}
            </span>
          </div>

          <div class="document-count-badge">
            {{ filteredDocuments.length }}
          </div>

        </div>


        <!-- Document List -->
        <div class="document-preview-sidebar__list">

          <button type="button" class="preview-document-item" *ngFor="
              let document of filteredDocuments;
              let i = index
            " [class.preview-document-item--active]="
              selectedDocument?.message_id === document.message_id
            " (click)="selectPreviewDocument(document, i)">

            <!-- File Icon -->
            <span class="preview-document-item__icon" [ngClass]="getFileClass(document.file_ext)">
              <i class="pi" [ngClass]="getFileIcon(document.file_ext)"></i>
            </span>


            <!-- File Information -->
            <span class="preview-document-item__content">

              <span class="preview-document-item__name" [title]="document.message">
                {{ document.message }}
              </span>

              <span class="preview-document-item__meta">

                <span>
                  {{ document.file_size }}
                </span>

                <span class="meta-separator">•</span>

                <span>
                  {{ document.file_ext | uppercase }}
                </span>

              </span>

            </span>


            <!-- Active Indicator -->
            <span class="preview-document-item__active-indicator" *ngIf="
                selectedDocument?.message_id === document.message_id
              ">
              <i class="pi pi-check"></i>
            </span>

          </button>


          <!-- Empty State -->
          <div class="document-preview-sidebar__empty" *ngIf="!filteredDocuments.length">
            <div class="empty-icon">
              <i class="pi pi-folder-open"></i>
            </div>

            <h5>No documents</h5>

            <p>No files are available for preview.</p>
          </div>

        </div>

      </aside>


      <!-- =====================================================
           MAIN PREVIEW
      ====================================================== -->
      <section class="document-preview-main">


        <!-- ===================================================
             PREVIEW HEADER
        ==================================================== -->
        <div class="document-preview-main__header">

          <div class="document-preview-main__title">

            <div class="document-preview-main__file-icon" [ngClass]="
                getFileClass(selectedDocument?.file_ext)
              ">
              <i class="pi" [ngClass]="
                  getFileIcon(selectedDocument?.file_ext)
                "></i>
            </div>

            <div class="document-preview-main__file-info">

              <h3 [title]="selectedDocument?.message">
                {{ selectedDocument?.message || 'Select a document' }}
              </h3>

              <p *ngIf="selectedDocument">

                <span>
                  {{ selectedDocument.file_size }}
                </span>

                <span class="title-separator">•</span>

                <span>
                  {{ selectedDocument.file_ext | uppercase }}
                </span>

              </p>

            </div>

          </div>


          <!-- =================================================
               NAVIGATION
          ================================================== -->
          <div class="document-preview-navigation" *ngIf="filteredDocuments.length">

            <button type="button" class="preview-nav-button" [disabled]="previewIndex <= 0" title="Previous document"
              aria-label="Previous document" (click)="previousPreview()">
              <i class="pi pi-chevron-left"></i>
            </button>

            <div class="preview-counter">
              <strong>{{ previewIndex + 1 }}</strong>
              <span>/</span>
              <span>{{ filteredDocuments.length }}</span>
            </div>

            <button type="button" class="preview-nav-button" [disabled]="
                previewIndex >= filteredDocuments.length - 1
              " title="Next document" aria-label="Next document" (click)="nextPreview()">
              <i class="pi pi-chevron-right"></i>
            </button>

          </div>

        </div>


        <!-- ===================================================
             PREVIEW BODY
        ==================================================== -->
        <div class="document-preview-main__body">


          <!-- =================================================
               VIDEO
          ================================================== -->
          <div class="media-viewer media-viewer--video" *ngIf="
              selectedDocument?.file_type === 'video' &&
              mediaContent?.file_type === 'video' &&
              inputSrc
            ">

            <div class="media-viewer__content">

              <vg-player (onPlayerReady)="videoPlayerInit($event)">

                <vg-overlay-play></vg-overlay-play>

                <vg-buffering></vg-buffering>

                <video #media [vgMedia]="media" id="singleVideo" crossorigin controlsList="nodownload" (timeupdate)="
                    getVideoPlayingOnTime(
                      $event.target.currentTime
                    )
                  ">
                  <source [src]="inputSrc" type="video/mp4" />
                </video>

                <vg-controls [vgAutohide]="true">

                  <vg-play-pause></vg-play-pause>

                  <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>

                  <vg-scrub-bar></vg-scrub-bar>

                  <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>

                  <vg-mute></vg-mute>

                  <vg-volume></vg-volume>

                  <vg-fullscreen></vg-fullscreen>

                </vg-controls>

              </vg-player>

            </div>

          </div>


          <!-- =================================================
               AUDIO
          ================================================== -->
          <div class="media-viewer media-viewer--audio" *ngIf="
              selectedDocument?.file_type === 'audio' &&
              mediaContent?.file_type === 'audio' &&
              inputSrc
            ">

            <div class="audio-preview-card">

              <div class="audio-preview-card__artwork">

                <div class="audio-preview-card__icon">
                  <i class="pi pi-volume-up"></i>
                </div>

              </div>

              <div class="audio-preview-card__info">

                <span class="audio-preview-card__label">
                  AUDIO PREVIEW
                </span>

                <h4>
                  {{ selectedDocument?.message }}
                </h4>

                <p>
                  Listen to the selected audio document.
                </p>

              </div>

              <vg-player class="audio-player" (onPlayerReady)="videoPlayerInit($event)">

                <audio #audio [vgMedia]="audio" id="myAudio" preload="metadata">
                  <source [src]="inputSrc" type="audio/mpeg" />
                </audio>

                <vg-controls>

                  <vg-play-pause></vg-play-pause>

                  <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>

                  <vg-scrub-bar></vg-scrub-bar>

                  <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>

                  <vg-mute></vg-mute>

                  <vg-volume></vg-volume>

                </vg-controls>

              </vg-player>

            </div>

          </div>


          <!-- =================================================
               IMAGE
          ================================================== -->
          <div class="media-viewer media-viewer--image" *ngIf="
              selectedDocument?.file_type === 'image' &&
              mediaContent?.view_Url
            ">

            <div class="image-viewer__toolbar">

              <span>
                <i class="pi pi-image"></i>
                Image Preview
              </span>

            </div>

            <div class="image-viewer__canvas">

              <img class="viewer-image" [src]="mediaContent.view_Url" [alt]="selectedDocument?.message"
                [ngxWatermark]="options" />

            </div>

          </div>


          <!-- =================================================
               DOCUMENT / APPLICATION
          ================================================== -->
          <div class="media-viewer media-viewer--document" *ngIf="
              selectedDocument?.file_type === 'application' &&
              selectedReadFile
            ">

            <!-- <div class="document-viewer__toolbar">

              <div>
                <i class="pi pi-file"></i>
                <span>Document Preview</span>
              </div>

              <span class="document-viewer__secure">
                <i class="pi pi-lock"></i>
                Secure Preview
              </span>

            </div> -->

            <div class="document-viewer__content">

              <ngx-doc-viewer [url]="selectedReadFile" viewer="google" [googleCheckContentLoaded]="true"
                [googleCheckInterval]="3000" [googleMaxChecks]="5" (loaded)="contentLoaded()">
              </ngx-doc-viewer>

            </div>

          </div>


          <!-- =================================================
               NO PREVIEW
          ================================================== -->
          <div class="preview-placeholder" *ngIf="!hasPreviewContent()">

            <div class="preview-placeholder__illustration">

              <div class="preview-placeholder__icon">
                <i class="pi pi-file"></i>
              </div>

            </div>

            <h4>Preview unavailable</h4>

            <p>
              This document cannot be previewed directly
              in your browser.
            </p>

            <span>
              Try selecting another document from the list.
            </span>

          </div>

        </div>

      </section>

    </div>

  </div>
</div>


<!-- =======================================================
     DOCUMENT EDITOR MODAL
======================================================== -->
<div class="modal-backdrop" *ngIf="showEditor">

  <div class="document-editor">

    <div class="document-editor__header">

      <div>
        <span class="editor-label">
          Document Editor
        </span>

        <h3>
          Edit Document
        </h3>
      </div>

      <button type="button" class="icon-button" (click)="closeEditor()">
        <i class="pi pi-times"></i>
      </button>

    </div>


    <div class="document-editor__body">
      <app-excel-editor [file]="upLoadedFileList[0] ?? null" [documentId]="documentId"
        [documentFileName]="documentFileName" [documentFileType]="documentFileType" [companyId]="companyIdForConversion"
        [classId]="selectedFolderId" [modelType]="activeFolderModelType" [documentTitle]="documentTitle"
        [stateCode]="selectedPolicy" [chatUserList]="selectedClassList" [isDownload]="isDownload"
        [docTrainId]="docTrainId" [messageId]="message_id" [(visible)]="showExcelEditor"
        (onSave)="onExcelEditorSave($event)" (onCancel)="onExcelEditorCancel()">
      </app-excel-editor>

    </div>


    <div class="document-editor__footer">

      <button type="button" class="btn btn-light" (click)="closeEditor()">
        Cancel
      </button>

      <button type="button" class="btn btn-primary" (click)="saveDocument()">
        <i class="pi pi-save"></i>
        Save & Complete
      </button>

    </div>

  </div>

</div>

<!-- Upload workflow -->
<app-document-upload *ngIf="showUpload" (close)="closeDocumentUpload()" (completed)="onUploadCompleted($event)">
</app-document-upload>

<!--Assessment-->
<app-assessment *ngIf="showAssessmentModal" [document]="selectedAssessmentDocument" (close)="closeAssessment()"
  (saved)="assessmentSaved($event)">
</app-assessment>

<!--Survey-->
<app-survey *ngIf="showSurveyModal" [document]="selectedSurveyDocument" (close)="closeSurvey()"
  (saved)="surveySaved($event)">
</app-survey>
<!--Poll-->
<app-poll ngIf></app-poll>
